import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { InsurancesService } from '../../services/insurances/insurances.service'; 
import { IInsurance } from '../../insurances/insurances.interfaces'; // Ajusta la ruta segons el teu projecte
import * as moment from 'moment';

@Component({
  selector: 'dialog-insurances-data',
  templateUrl: './dialog.component.ins.html', // Recorda reanomenar el fitxer HTML a .ins.html
  styleUrls: ['./dialog.component.ins.scss'], // Recorda reanomenar el fitxer SCSS a .ins.scss
  providers: [DatePipe, InsurancesService]
})
export class DialogInsurances implements OnInit {
  
  public error: string = '';
  public dia: string = null;
  public showAsyncProgress: boolean = false;
  public editInsuranceData: IInsurance;
  
  // Llistes per als autocomplets de la taula d'assegurances
  public plateList: any[] = [];
  public nameList: any[] = [];
  public companyList: any[] = [];
  public policyNumberList: any[] = [];
  
  public userInfo: any = {};

  constructor(
    private datePipe: DatePipe, 
    public dialogRef: MatDialogRef<DialogInsurances>, 
    @Inject(MAT_DIALOG_DATA) public data: any, 
    public insService: InsurancesService
  ) { 
    this.editInsuranceData = data.dades;
    
    // Carrega dels autocomplets basats en els camps d'insurances
    this.insService.getAutocomplete("plate").subscribe(result => { this.plateList = result; });
    this.insService.getAutocomplete("name").subscribe(result => { this.nameList = result; });
    this.insService.getAutocomplete("company").subscribe(result => { this.companyList = result; });
    this.insService.getAutocomplete("policy_number").subscribe(result => { this.policyNumberList = result; });
   
    if (!this.dia) this.dia = moment().format("YYYY-MM-DD");
    this.userInfo = data.user;
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  desar(): void {
    this.dialogRef.close(this.editInsuranceData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  ngOnInit() { }
}